// MARK: React
import * as React from "react";
import "./style.scss";

// Mobx
import { observer } from "mobx-react";
import HotelStore from "../../../../../stores/HotelStore";

// MARK: Components
import TextField from "../../../../../components/TextField";

// Resources
import strings from "../../../../../resources/strings";
import ImageCase from "../../../../../components/ImageCase";
import { Divider } from "@material-ui/core";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class HotelAssets extends React.Component<IProps> {
	public render() {
		const { hotelStore } = this.props;
		return (
			<>
				<h2>{strings.hotel.edit.sections.content}</h2>
				<Divider className="divider" />
				<TextField
					label={strings.hotel.edit.fields.videoUrl}
					name="videoUrl"
					value={hotelStore.videoUrl}
					onChange={hotelStore.handleValueChange}
					disabled={hotelStore.loading}
					required={true}
				/>
				<TextField
					label={strings.hotel.edit.fields.roomsDescription}
					name="roomsDescription"
					multiline={true}
					value={hotelStore.roomsDescription}
					onChange={hotelStore.handleValueChange}
					disabled={hotelStore.loading}
				/>
				{/*<h2>{strings.hotel.edit.sections.logos}</h2>
				<ImageCase
					key="horizontalLogoImageCase"
					title={strings.hotel.edit.fields.logos.horizontal}
					onAddItem={hotelStore.logoHorizontalImageService.selectSingleImage}
					onRemoveItem={hotelStore.logoHorizontalImageService.removeImage}
					onReloadItem={hotelStore.logoHorizontalImageService.reloadImage}
					imageUploaders={hotelStore.logoHorizontalImageService.singleImageUploader}
				/>
				<ImageCase
					key="squaredLogoImageCase"
					title={strings.hotel.edit.fields.logos.squared}
					onAddItem={hotelStore.logoSquaredImageService.selectSingleImage}
					onRemoveItem={hotelStore.logoSquaredImageService.removeImage}
					onReloadItem={hotelStore.logoSquaredImageService.reloadImage}
					imageUploaders={hotelStore.logoSquaredImageService.singleImageUploader}
				/>
				<ImageCase
					key="whiteLogoImageCase"
					title={strings.hotel.edit.fields.logos.white}
					onAddItem={hotelStore.logoWhiteImageService.selectSingleImage}
					onRemoveItem={hotelStore.logoWhiteImageService.removeImage}
					onReloadItem={hotelStore.logoWhiteImageService.reloadImage}
					imageUploaders={hotelStore.logoWhiteImageService.singleImageUploader}
				/>
				<Divider className="divider" />*/}
				<ImageCase
					title={strings.hotel.edit.fields.image}
					onAddItem={hotelStore.imageService.selectSingleImage}
					onRemoveItem={hotelStore.imageService.removeImage}
					onReloadItem={hotelStore.imageService.reloadImage}
					imageUploaders={hotelStore.imageService.singleImageUploader}
				/>
			</>
		);
	}
}
